module.exports = __webpack_public_path__ + "img/logo-dark.5290c040.png";